import { DirectionPage, MetaData, SubDirectionPage, TextPage } from '@/components'
import calcCurrentDirection from '@/lib/calcCurrentDirection'
import shouldNoIndexDirection from '@/lib/shouldNoIndexDirection'

const SIMPLE_TEXT_PAGE_SLUGS = ['patient-and-family-bill-of-rights-and-responsibilities']

function getRequestSlug(typeSlug, directions = []) {
  const cur = calcCurrentDirection(typeSlug, directions, directions[0])
  return typeSlug !== cur?.slug
    ? typeSlug
    : cur?.children?.[0]?.slug || cur?.slug || typeSlug
}

async function fetchDirectionsBySlug(api, slug) {
  try {
    return [slug, await api.directions({ direction: slug })]
  } catch {
    return [slug, {}]
  }
}

export default function NextTypePage(props) {
  const { type, data, robots, typeSlug } = props;
  const { title, description } = data.meta || {};
  const isSimple = SIMPLE_TEXT_PAGE_SLUGS.includes(typeSlug || data.slug)

  switch (type) {
    case 'direction':
      if (isSimple) {
        return (
          <>
            <MetaData title={title || data.title} description={description} robots={robots} />
            <TextPage {...data} simple />
          </>
        )
      }

      return (
        <>
          <MetaData title={title || data.title} description={description} robots={robots} />
          <DirectionPage {...data} />
        </>
      )
    case 'subdirection':
      return (
        <>
          <MetaData title={title || data.title} description={description} robots={robots} />
          <SubDirectionPage {...data} />
        </>
      )
    case 'text_page':
      return (
        <>
          <MetaData title={title || data.title} description={description}/>
          <TextPage {...data} simple={isSimple} />
        </>
      )
  }
}

NextTypePage.getInitialProps = async ({ query, api }) => {
  const { typeSlug, ...otherQueries } = query

  const response = await api.type({ slug: typeSlug, ...otherQueries })

  const { page_type: type, data } = response

  if (type === 'direction' || type === 'subdirection') {
    const preliminaryDirections = data.directions || []
    const preliminaryRequestSlug = getRequestSlug(typeSlug, preliminaryDirections)
    const slugsToFetch = new Set([typeSlug])

    if (preliminaryRequestSlug !== typeSlug) {
      slugsToFetch.add(preliminaryRequestSlug)
    }

    const directionsBySlug = Object.fromEntries(
      await Promise.all([...slugsToFetch].map((slug) => fetchDirectionsBySlug(api, slug)))
    )

    const directionsData = directionsBySlug[typeSlug] || {}
    const directions = directionsData.directions || data.directions || []
    const requestSlug = getRequestSlug(typeSlug, directions)

    let servicesData = directionsBySlug[requestSlug]
    if (requestSlug !== typeSlug && !servicesData) {
      servicesData = (await fetchDirectionsBySlug(api, requestSlug))[1]
    }

    const services =
      requestSlug !== typeSlug
        ? servicesData?.services || []
        : directionsData.services || []
    const current_direction =
      requestSlug !== typeSlug
        ? servicesData?.current_direction
        : directionsData.current_direction

    const short_content = directionsData.short_content || data.short_content
    // Учитываем и услуги текущего slug, и подставленные услуги первого ребёнка
    const robots = shouldNoIndexDirection({
      services,
      short_content,
      blocks: data.blocks,
    })
      ? 'noindex, follow'
      : undefined

    return {
      type,
      pageType: 'direction',
      robots,
      data: {
        ...data,
        banners: directionsData.banners,
        directions,
        short_content,
        services,
        current_direction,
      },
    }
  }

  return { type, data }
}
